export const genesysErrorMsg = {
  WS_CONNECTION_CLOSED:
    'Genesys WS connection closed. Contact @platcon-help on slack',
  WS_ERROR: 'Genesys WS error occured. Contact @platcon-help on slack',
  SUBSCRIPTION_ERROR:
    'Error subscribing to Genesys topic. Contact @platcon-help on slack',
};
